<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('zijinminxi')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="cu-list menu-avatar" style="padding: 0px 5px;">
			<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;">
				<text class="avatar-text">
					<span>收益</span>
				</text>
				<div class="content" style="left: 100px;">
					<div class=" text-sm flex">
						<div class="text-cut text-cyan" style="font-size: 12px;">
							USA-250719030429 轮
						</div>
					</div>
					<div class=" text-sm flex">
						<div class="text-cut text-cyan" style="font-size: 12px;">大跌/3.7</div>
						<div class="cu-tag radius light text-xs margin-left bg-green" style="min-width: 50px;">成功</div>
					</div>
					<div class="text-yellow" style="font-size: 13px;">07/19/2025 07:30:00</div>
					<div class="text-sm flex"></div>
				</div>
				<div class="action" style="width: 80px;">
					<div class="cu-tag radius bg-red " style="min-width: 65px;">+502656.1</div>
				</div>
			</div>
			<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;">
				<div class="cu-avatar round lg margin-xs bg-gradual-blue"
					style="white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
					<text class="avatar-text">
						<span>投资</span>
					</text>
				</div>
				<div class="content" style="left: 100px;">
					<div class=" text-sm flex">
						<div class="text-cut text-cyan" style="font-size: 12px;">USA-250719030429 轮</div>
					</div>
					<div class=" text-sm flex">
						<div class="text-cut text-cyan" style="font-size: 12px;">大跌/3.7</div>
						<div class="cu-tag radius light text-xs margin-left bg-green" style="min-width: 50px;">成功</div>
					</div>
					<div class="text-yellow" style="font-size: 13px;">07/19/2025 07:27:11</div>
					<div class=" text-sm flex"></div>
				</div>
			</div>
			<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;">
				<div class="cu-avatar round lg margin-xs bg-gradual-orange"
					style="white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
					<text class="avatar-text">
						<span>充值</span>
					</text>
				</div>
				<div class="content" style="left: 100px;">
					<div class=" text-sm flex"></div>
					<div class="text-yellow" style="font-size: 13px;">05/16/2025 22:58:58
						<div class="cu-tag radius light text-xs  bg-green" style="margin-left: 10px;">
							成功
						</div>
					</div>
					<div class=" text-sm flex">
						<div class="text-cut text-blue" style="font-size: 13px;">Serial No：640307133870641152</div>
					</div>
				</div>
				<div class="action" style="width: 80px;">
					<div class="cu-tag radius bg-red " style="min-width: 65px;">+15001.3</div>
				</div>
			</div>
			<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;">
				<div class="cu-avatar round lg margin-xs bg-gradual-orange"
					style="white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
					<text class="avatar-text">
						<span>充值</span>
					</text>
				</div>
				<div class="content" style="left: 100px;">
					<div class=" text-sm flex"></div>
					<div class="text-yellow" style="font-size: 13px;">
						05/16/2025 22:58:58
						<div class="cu-tag radius light text-xs  bg-green" style="margin-left: 10px;">成功</div>
					</div>
					<div class=" text-sm flex">
						<div class="text-cut text-blue" style="font-size: 13px;">Serial No：640307133870641152</div>
					</div>
				</div>
				<div class="action" style="width: 80px;">
					<div class="cu-tag radius bg-red " style="min-width: 65px;">+15001.3</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "CapitalDetail",
		components: {},
		data() {
			return {};
		},
		methods: {
			changego() {
				this.$router.go(-1);
			},
		},
	};
</script>
<style>
	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}




	.cu-list.menu-avatar>.cu-item {
		position: relative;
		display: flex;
		padding-right: 5px;
		height: 80px;
		background-color: #fff;
		justify-content: flex-end;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu-avatar>.cu-item>.cu-avatar {
		position: absolute;
		left: 17px;
	}

	.cu-avatar.lg {
		width: 55px;
		height: 55px;
		font-size: 2em;
	}

	.bg-gradual-yellow {
		background-image: linear-gradient(45deg, #e6e813, #dd8139);
		color: #fff;
	}

	.margin-xs {
		margin: 5px;
	}

	.cu-avatar {
		font-variant: small-caps;
		margin: 0;
		padding: 0;
		display: inline-flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		background-color: #ccc;
		color: #fff;
		white-space: nowrap;
		position: relative;
		width: 36px;
		height: 36px;
		background-size: cover;
		background-position: 50%;
		vertical-align: middle;
		font-size: 1.5em;
	}

	.cu-avatar .avatar-text {
		font-size: .4em;
	}

	.cu-list.menu-avatar>.cu-item .content {
		position: absolute;
		left: 83px;
		width: calc(100% - 55px - 34px - 68px - 11px);
		line-height: 1.6em;
	}

	.cu-list.menu-avatar>.cu-item .content>div:first-child {
		font-size: 17px;
		display: flex;
		align-items: center;
	}

	.flex {
		display: flex;
	}

	.text-yellow,
	.line-yellow,
	.lines-yellow {
		color: #fbbd08;
	}

	.cu-list.menu-avatar>.cu-item .flex .text-cut {
		max-width: 292px;
	}

	.text-cyan,
	.line-cyan,
	.lines-cyan {
		color: #1cbbb4;
	}

	.text-cut {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.bg-green.light {
		color: #39b54a;
		background-color: #d7f0db;
	}

	.text-xs {
		font-size: 11px;
	}

	.margin-left {
		margin-left: 17px;
	}

	.cu-tag {
		font-size: 13px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 9px;
		height: 27px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.radius {
		border-radius: 3px;
	}

	.cu-list.menu-avatar>.cu-item .action {
		width: 57px;
		text-align: center;
	}

	.bg-red {
		background-color: #e54d42;
		color: #fff;
	}

	.cu-list.menu-avatar>.cu-item:after,
	.cu-list.menu>.cu-item:after {
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		width: 200%;
		height: 200%;
		border-bottom: 0.5px solid #ddd;
		border-radius: inherit;
		content: " ";
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		pointer-events: none;
	}

	.bg-gradual-blue {
		background-image: linear-gradient(45deg, #0081ff, #1cbbb4);
		color: #fff;
	}

	.text-blue,
	.line-blue,
	.lines-blue {
		color: #0081ff;
	}

	.bg-gradual-orange {
		background-image: linear-gradient(45deg, #ff9700, #ed1c24);
		color: #fff;
	}
</style>